var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "Message"
  }, [_c('div', {
    class: ("Message-" + (_vm.type)),
    attrs: {
      "id": 'js-message-' + _vm.inputId,
      "tabindex": _vm.getTabIndex
    }
  }, [_vm.isInformationMessage ? _c('information-icon', {
    staticClass: "Message-informationIcon"
  }) : _vm._e(), _c('div', {
    staticClass: "Message-text",
    class: _vm.getInputClass
  }, [_vm._t("default")], 2)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }